import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const DeleteApplications = () => {
    const [applications, setApplications] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchDeletedApplications();
    }, []);

    const fetchDeletedApplications = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/applications/deleted');
            const data = await response.json();
            setApplications(data);
        } catch (error) {
            console.error('Error fetching deleted applications:', error);
        }
    };

    const handleRestore = async (applicationId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to restore this application?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/applications/restore/${applicationId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setApplications(applications.filter(application => application.id !== applicationId));
                        Swal.fire({
                            title: "Restored!",
                            text: "The application has been restored.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to restore application');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to restore the application.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error restoring application:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to restore the application.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handlePermanentDelete = async (applicationId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This action cannot be undone. The application will be permanently deleted!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete permanently!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/applications/delete/permanent/${applicationId}`, {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        setApplications(applications.filter(application => application.id !== applicationId));
                        Swal.fire({
                            title: "Deleted!",
                            text: "The application has been permanently deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete application permanently');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to permanently delete the application.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting application permanently:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to permanently delete the application.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter applications based on search term
    const filteredApplications = applications.filter(app => 
        (app.appName && app.appName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (app.ownerName && app.ownerName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (app.ownerEmail && app.ownerEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (app.contact && app.contact.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (

        <div>

            <AdminDashboard />

            <div className='AllViews-admin-course'>

                <div className="search-icon-admin admin-course-search">
                    <h1>DELETED APPLICATIONS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                                <tr>
                                    <th>Application Name</th>
                                    <th>Owner Name</th>
                                    <th>Owner Email</th>
                                    <th>Owner Contact</th>
                                    <th>Link</th>
                                    <th>PDF Application</th>
                                    <th>Expire Time</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredApplications.map((application) => (
                                    <tr key={application.id}>
                                        <td>{application.appName}</td>
                                        <td>{application.ownerName}</td>
                                        <td>{application.ownerEmail}</td>
                                        <td>{application.contact}</td>
                                        <td>
                                            <a href={application.link} target="_blank" rel="noopener noreferrer">
                                                View Link
                                            </a>
                                        </td>
                                        <td>
                                            <a href={`https://api.myskills.lk/Upload/pdf/${application.application}`} target="_blank" rel="noopener noreferrer">
                                                View PDF
                                            </a>
                                        </td>
                                        <td>
                                            {new Date(application.expire_time).toLocaleString('en-US', {
                                                year: 'numeric',
                                                month: '2-digit',
                                                day: '2-digit',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true
                                            }).replace(',', ' -')}
                                        </td>
                                        <td>
                                            {application.website ? (
                                                <a href={application.website} target="_blank" rel="noopener noreferrer" id='view-website'>WEBSITE</a>
                                            ) : (
                                                <span style={{ color: '#999' }}>No Website</span>
                                            )}
                                        </td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='restore-details' onClick={() => handleRestore(application.id)}>RESTORE</a>
                                            <a href="#!" id='del-details' onClick={() => handlePermanentDelete(application.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                </div>

            </div>



        </div>

    )

}

export default DeleteApplications